import Loginform from "../../components/Auth/Loginform";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import AuthLayout from "../../components/Layout/AuthLayout";

const Login = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <AuthLayout
      title={language ? "लॉग इन करें" : "Log in"}
      showLanguageToggle={true}
    >
      <Loginform />
    </AuthLayout>
  );
};

export default Login;
